import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable({ providedIn: 'root' })
@Pipe({ name: 'confidencePercent' })
export class ConfidencePercentPipe implements PipeTransform {
    constructor(private translateService: TranslateService) {}

    transform(value: number): string {
        return this.translateService.instant('Confidence') + ': ' + (value * 100).toFixed(1) + '%';
    }
}
